import { Component, ViewChild, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  EwentsToastService,
  EwentsWentyComponent,
  provideWenty,
} from '@ewentscompany/ewents-components';
import { extractErrorMessage } from '@ewentscompany/ewents-settings';
import { of } from 'rxjs';
import { LoginService } from '../auth/login.service';
import { ComplianceService } from '../compliance/compliance.service';
import { getServiceUrl, SERVICES } from '../shared/constants/api.constants';
import { DeviceInfoService } from '../shared/services/device-info.service';
import { dlpProtectedDownload } from '../shared/utils/dlp-protected-download';

export const WENTY_SUPPORT_TICKET_PROMPT = "Hi Wenty, i'd like to submit a ticket";

/** CRM host for the shared Wenty panel (`surface=crm`, model governed by CRM settings). */
@Component({
  selector: 'app-wenty',
  standalone: true,
  imports: [EwentsWentyComponent],
  template: '<ewents-wenty />',
  providers: [
    provideWenty(() => {
      const deviceInfo = inject(DeviceInfoService);
      const dialog = inject(MatDialog);
      const login = inject(LoginService);
      const compliance = inject(ComplianceService);
      const toast = inject(EwentsToastService);
      return {
        surface: 'crm',
        getBaseUrl: () => getServiceUrl(SERVICES.WENTY),
        getDeviceHeaders: () => deviceInfo.getSessionHeaders(),
        // Wenty files are CRM report exports (same class as vendor/user .docx exports).
        downloadFile: file =>
          dlpProtectedDownload({
            dialog,
            login,
            settings$: compliance.getDlpSettings(),
            label: 'CONFIDENTIAL',
            filename: file.filename,
            download$: of(file.blob),
            onAlert: msg => toast.warning(msg),
          }).subscribe({ error: err => toast.error(extractErrorMessage(err)) }),
      };
    }),
  ],
})
export class WentyComponent {
  @ViewChild(EwentsWentyComponent, { static: true }) private panel?: EwentsWentyComponent;

  openWithUserMessage(text: string): void {
    this.panel?.openWithUserMessage(text);
  }
}
